export default __webpack_public_path__ + "static/Blogs-banner-17ca51ef36b65bc97d8cd3307a507a6d.svg";